// extracted by mini-css-extract-plugin
export default {"PfsArchway":"PFSArchway_PfsArchway__Cg+Zv","content":"PFSArchway_content__DTDpk","homeBtn":"PFSArchway_homeBtn__j4364","logo":"PFSArchway_logo__pDQ9G"};